(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-dw-collection-hub]').forEach((hub) => {
      if (hub.dataset.dwReady) return;
      hub.dataset.dwReady = 'true';

      const slider = hub.querySelector('[data-dw-drogisterij-slider]');
      if (slider) {
        const slides = [...slider.querySelectorAll('[data-dw-drogisterij-slide]')];
        const dots = [...slider.querySelectorAll('[data-dw-drogisterij-dot]')];
        const previousSlide = slider.querySelector('[data-dw-drogisterij-prev]');
        const nextSlide = slider.querySelector('[data-dw-drogisterij-next]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let currentIndex = 0;
        let timer;

        const stop = () => window.clearInterval(timer);
        const start = () => {
          stop();
          if (!reduceMotion.matches && slides.length > 1) {
            timer = window.setInterval(() => show(currentIndex + 1), 6500);
          }
        };
        const show = (requestedIndex, restart = false) => {
          currentIndex = (requestedIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const active = index === currentIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            slide.inert = !active;
          });
          dots.forEach((dot, index) => {
            const active = index === currentIndex;
            dot.classList.toggle('is-active', active);
            if (active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (restart) start();
        };

        previousSlide?.addEventListener('click', () => show(currentIndex - 1, true));
        nextSlide?.addEventListener('click', () => show(currentIndex + 1, true));
        dots.forEach((dot, index) => dot.addEventListener('click', () => show(index, true)));
        slider.addEventListener('pointerenter', stop);
        slider.addEventListener('pointerleave', start);
        slider.addEventListener('focusin', stop);
        slider.addEventListener('focusout', (event) => {
          if (!slider.contains(event.relatedTarget)) start();
        });
        reduceMotion.addEventListener?.('change', start);
        hub.addEventListener('dw:dispose', () => stop(), { once: true });
        show(0);
        start();
      }

      const row = hub.querySelector('[data-dw-brandrow]');
      if (!row) return;
      const previous = hub.querySelector('[data-dw-brand-prev]');
      const next = hub.querySelector('[data-dw-brand-next]');
      const update = () => {
        if (previous) previous.disabled = row.scrollLeft <= 1;
        if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
      };
      const move = (direction) => row.scrollBy({
        left: direction * Math.max(180, Math.round(row.clientWidth * .72)),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      row.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(row);
        hub.addEventListener('dw:dispose', () => observer.disconnect(), { once: true });
      }
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-dw-collection-hub]').forEach((hub) => hub.dispatchEvent(new Event('dw:dispose'))));
})();

